import { useState } from "react";
import css from "./Checkbox.module.css";

const Checkbox = ({ center, checked, children, light, onClick, weight }) => {
  const [isChecked, setIsChecked] = useState(false);

  // Dynamic tag assignment based on state
  const Component = checked ? "div" : "button";

  const toggleCheck = () => {
    setIsChecked((old) => !old);
  };

  return (
    <Component
      className={`${css.main} ${center ? css.center : ""}`}
      onClick={() => {
        toggleCheck();
        // Note: isChecked inside this closure refers to the state BEFORE toggleCheck runs
        onClick?.(weight, isChecked);
      }}
    >
      <div
        className={`${css.checkbox} ${light ? css.light : ""} ${
          checked || isChecked ? css.checked : ""
        }`}
      >
        {(checked || isChecked) && (
          <img
            className={css.check}
            src={require("../../../images/check.png")}
            alt="check"
          />
        )}
      </div>
      <div className={css.content}>{children}</div>
    </Component>
  );
};

export default Checkbox;
